import { render, staticRenderFns } from "./StudentAppHeader.vue?vue&type=template&id=c163cf32&scoped=true&"
import script from "./StudentAppHeader.vue?vue&type=script&lang=js&"
export * from "./StudentAppHeader.vue?vue&type=script&lang=js&"
import style0 from "./StudentAppHeader.vue?vue&type=style&index=0&id=c163cf32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c163cf32",
  null
  
)

export default component.exports